<div class="row justify-content-center">
    <div class="col-md-12">
        <div class="card my-5">
            <div class="card-header">
                <h3 class="text-center">
                    SYSTEM ERROR
                </h3>
            </div>
            <div class="card-body">
                <div class="alert alert-primary fadein">
                    <strong><p>
                        Please notify Office of Finance of your problem at 1-844-663-4411 (during weekday business hours) or send an email to
                        Customer Service at <a
                            href="mailto:Finance.CustomerService@lacity.org?subject=System Problem with Web {{appName}}"
                            class="undln" (mouseout)="mouseoutmsg()"
                            (mouseover)="mouseovermsg()">
                            Finance.CustomerService@lacity.org</a>.
                    </p>
                    <p>Please click <a href="{{startPage}}" class="undln">here</a> to try again.</p>
                    </strong>
                </div>
            </div>
        </div>
    </div>
</div>